import React from 'react'
import Header from '../HeaderandFooter/Header'
import Cheatsheets from './Cheatsheets'
import SidebarOptions from '../HeaderandFooter/SidebarOptions'

const MainCheatsheets = () => {
    return (
        <>
            <Header />
            <SidebarOptions />
            <div className="sectiondataCheatSheet">
                <Cheatsheets />
            </div>
        </>
    )
}

export default MainCheatsheets